import styled from "styled-components";

export const AboutWrapper = styled.section`
  margin-bottom: 200px;
  @media screen and (max-width: 768px) {
    position: relative;
    margin-bottom: 100px;
  }
  .quotes__wrapper {
    position: relative;
    top: 80px;
    @media screen and (max-width: 768px) {
      top: 40px;
    }
  }
`;

export const AboutInfo = styled.article`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  position: relative;
  z-index: 3;
  margin: auto;
  margin-top: 200px;
  > div:first-child {
    margin-right: 10%;
  }
  p {
    color: #f8f8f8;
    font-size: 1.2rem;
  }
  @media screen and (max-width: 968px) {
    flex-direction: column;
    margin-top: 120px;
    > div:first-child {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }
`;
